import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import * as comp from './components/index'



const routes: Routes = [
  { path: '', component: comp.ContainerComponent, canActivate:[MsalGuard] },
  { path: 'container', component: comp.ContainerComponent, canActivate:[MsalGuard] },
  { path: 'interstitial', component: comp.InterstitialComponent },
  { path: 'login', component: comp.LoginComponent },
  { path: 'logout', component: comp.LogoutComponent },
  { path: 'changePassword', component: comp.ChangePasswordComponent },
  { path: 'applicationInfo', component: comp.ApplicationInfoComponent },
  { path: 'dashboard', component: comp.DashboardComponent },
  { path: 'assignedRequests', component: comp.AssignedRequestsComponent },
  { path: 'fullServicePricingRequests', component: comp.FullServicePricingRequestsComponent },
  { path: 'requestsGrid', component: comp.RequestsGridComponent },
  { path: 'requestHistory', component: comp.RequestHistoryComponent },
  { path: 'employeesGrid', component: comp.EmployeesGridComponent },
  { path: 'massUpdates', component: comp.MassUpdatesComponent },
  { path: 'createAccountsReceivableUpdate', component: comp.CreateAccountsReceivableUpdateRequest },
  { path: 'createInvoiceStatementCopies', component: comp.CreateInvoiceStatementCopiesRequestComponent },
  { path: 'createCollectionsSetup', component: comp.CreateCollectionsSetupRequestComponent },
  { path: 'createBillingDiscrepancy', component: comp.CreateBillingDiscrepancyRequestComponent },
  { path: 'createSoldToCustomer', component: comp.CreateSoldToCustomerRequestComponent },
  { path: 'createSuppressCustomer', component: comp.CreateSuppressCustomerRequestComponent },
  { path: 'createUnsuppressCustomer', component: comp.CreateUnsuppressCustomerRequestComponent },
  { path: 'createUpdatePricing', component: comp.CreateUpdatePricingRequestComponent },
  { path: 'createMiscellaneous', component: comp.CreateMiscellaneousRequestComponent },
  { path: 'createFullServiceCustomer', component: comp.CreateFullServiceCustomerRequestComponent },
  { path: 'createMICRChanges', component: comp.CreateMICRChangesRequestComponent },
  { path: 'createPartnerFunctions', component: comp.CreatePartnerFunctionsRequestComponent },
  { path: 'createPayer', component: comp.CreatePayerRequestComponent },
  { path: 'createPayerLinkages', component: comp.CreatePayerLinkagesRequestComponent },
  { path: 'createEquipmentOnly', component: comp.CreateEquipmentOnlyRequestComponent },
  { path: 'createDriver', component: comp.CreateDriverRequestComponent },
  { path: 'createMaintainCustomer', component: comp.CreateMaintainCustomerRequestComponent },
  { path: 'createEquipmentInstall', component: comp.CreateEquipmentInstallRequestComponent },
  { path: 'createEquipmentRemove', component: comp.CreateEquipmentRemoveRequestComponent },
  { path: 'createEquipmentSwap', component: comp.CreateEquipmentSwapRequestComponent },
  { path: 'createEquipmentMove', component: comp.CreateEquipmentMoveRequestComponent },
  { path: 'createEquipmentSurvey', component: comp.CreateEquipmentSurveyRequestComponent },
  { path: 'createEquipmentMaintenance', component: comp.CreateEquipmentMaintenanceRequestComponent },
  { path: 'createPaperworkOnly', component: comp.CreatePaperworkOnlyMoveRequestComponent },
  { path: 'createVisitPlanUpdate', component: comp.CreateVisitPlanUpdateRequestComponent },
  { path: 'createZRPartnerUpdate', component: comp.CreateZRPartnerUpdateRequestComponent },
  { path: 'createFullServicePricing', component: comp.CreateFullServicePricingRequestComponent },
  { path: 'createAccountsReceivableUpdate', component: comp.CreateAccountsReceivableUpdateRequest },
  { path: 'domainRecords', component: comp.DomainRecordGridComponent },
  { path: 'importAudit', component: comp.ImportAuditGridComponent },
  { path: 'keyAccounts', component: comp.KeyAccountGridComponent },
  { path: 'models', component: comp.ModelGridComponent },
  { path: 'modelGroups', component: comp.ModelGroupGridComponent },
  { path: 'primaryGroupOverrides', component: comp.PrimaryGroupOverrideGridComponent },
  { path: 'requestTypes', component: comp.RequestTypeGridComponent },
  { path: 'vendSizeFlavorXrefs', component: comp.VendSizeFlavorXrefGridComponent },
  { path: 'packageConfigs', component: comp.FullServicePackageConfigGridComponent },
  { path: 'logMessages', component: comp.LogMessagesGridComponent },
  { path: 'maintainDSDFreeze', component: comp.MaintainDSDFreezeComponent },
  { path: 'maintainSalesOfficeRequestTypes', component: comp.MaintainSalesOfficeRequestTypes },
  { path: 'userMessageEdit', component: comp.UserMessageEditComponent },
  { path: 'container', component: comp.ContainerComponent },
  { path: 'uploadCompletionInfo', component: comp.UploadCompletionInfoComponent },
  { path: 'equipmentTemplateRuleGrid', component: comp.EquipmentTemplateRuleGridComponent },
  { path: 'exportFieldGrid', component: comp.ExportFieldGridComponent },
  { path: 'fieldFieldGrid', component: comp.FileFieldGridComponent },
  { path: 'exportFileGrid', component: comp.ExportFileGridComponent },
  { path: 'requestTypeFileGrid', component: comp.RequestTypeFileComponent },
  { path: 'requestExportPropertyValueGrid', component: comp.RequestExportPropertyValueGridComponent },
  { path: 'requestExportFileDataGrid', component: comp.RequestExportFileDataGridComponent },
  { path: 'activityReasonGrid', component: comp.ActivityReasonGridComponent },
  { path: 'contactValidationGrid', component: comp.ContactValidationGridComponent },
  { path: 'salesOfficeGrid', component: comp.SalesOfficeGridComponent },
  { path: 'validationGrid', component: comp.ValidationGridComponent },
  { path: 'equipmentGrid', component: comp.EquipmentGridComponent },
  { path: 'convertEquipmentRequests', component: comp.ConvertEquipmentRequestsComponent },
  { path: 'salesOfficeApproverGrid', component: comp.SalesOfficeApproverGridComponent },
  { path: 'employeeActivationRequestsGrid', component: comp.EmployeeActivationRequestsGridComponent }
];

export function isInIframe() {
  return window !== window.parent && !window.opener;
}


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    //     enableTracing: true,
    //     useHash: false,
    initialNavigation: !isInIframe() 
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
